import React, {useMemo} from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Divider,
  FormHelperText,
  Stack,
  Typography,
} from "@mui/material";
import GroupMemberPicker, {
  type SearchUser,
} from "src/views/admin/groups/GroupMemberPicker";
import { useGetUserDetails } from "src/helpers/UserDetails";

interface TransferOwnershipSectionProps {
  open: boolean;
  tid: string;
  value: SearchUser | null;
  onChange: (user: SearchUser | null) => void;
  onRequestTransfer: () => void;
  isLoading: boolean;
  errorMessage: string | null;
  helperText: string;
}

const TransferOwnershipSection: React.FC<TransferOwnershipSectionProps> = ({
  open,
  tid,
  value,
  onChange,
  onRequestTransfer,
  isLoading,
  errorMessage,
  helperText,
}) => {
  const currentUser = useGetUserDetails();

  const excludedIds = useMemo(() => {
    return currentUser ? [currentUser.id] : []
  }, [currentUser]);

  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Transfer ownership
      </Typography>
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <Stack direction="row" spacing={2} alignItems="center">
        <Stack sx={{ flex: 1 }}>
          <GroupMemberPicker
            open={open}
            excludeIds={excludedIds}
            value={value}
            onChange={onChange}
            label="Search for the new owner"
            textFieldTestId={`${tid}-transfer-search`}
          />
        </Stack>
        <Button
          variant="outlined"
          color="warning"
          size="small"
          disabled={!value || isLoading}
          data-testid={`${tid}-transfer-btn`}
          onClick={onRequestTransfer}
        >
          {isLoading ? <CircularProgress size={20} /> : "Transfer"}
        </Button>
      </Stack>
      <FormHelperText>{helperText}</FormHelperText>
    </>
  );
}

export default TransferOwnershipSection;
